import { routes as routeConfig } from "../config/route-config";

const AnalyticsIcon = "ic-statistics-2.svg";
const OrdersIcon = "ic-contact-phone-2.svg";
const OverviewIcon = "overview-icon.svg";
const FleetIcon = "ic-ecommerce-delivery.svg";
const ClientsIcon = "ic-actions-user.svg";
const WarningsIcon = "red-flags-white.svg";
const WarehouseIcon = "ic-ecommerce-house-white.svg";
const ExpenseTrackerIcon = "money.svg";
const EBMIcon = "receipt_white.svg";
const BIIReportingIcon = "warning-white.svg";
const EnergyIcon = "bolt.svg";

export const manageSidebarMenus = () => [
  {
    name: routeConfig.DepotProfile.name,
    icon: OverviewIcon,
    subMenus: [],
    active: false,
    url: routeConfig.DepotProfile.url
  },
  {
    name: routeConfig.Orders.name,
    icon: OrdersIcon,
    subMenus: [],
    active: false,
    url: routeConfig.Orders.url
  },
  {
    name: routeConfig.Fleet.name,
    url: routeConfig.Fleet.url,
    icon: FleetIcon,
    active: false,
    subMenus: []
  },

  {
    name: routeConfig.Users.name,
    icon: ClientsIcon,
    subMenus: [],
    active: false,
    url: routeConfig.Users.url,
    urlKey: routeConfig.Users.url
  },
  {
    name: routeConfig.Warehouse.name,
    icon: WarehouseIcon,
    subMenus: [],
    active: false,
    url: routeConfig.Warehouse.url,
    urlKey: routeConfig.Warehouse.url
  }
];

export const moreSidebarMenus = () => [
  {
    name: routeConfig.Analytics.name,
    icon: AnalyticsIcon,
    subMenus: [],
    active: false,
    url: routeConfig.Analytics.url
  },
  {
    name: routeConfig.energy.name,
    icon: EnergyIcon,
    subMenus: [],
    active: false,
    url: routeConfig.energy.url
  },
  {
    name: routeConfig.EBM.name,
    icon: EBMIcon,
    subMenus: [],
    active: false,
    url: routeConfig.EBM.url
  },
  {
    name: routeConfig.Finances.name,
    icon: ExpenseTrackerIcon,
    subMenus: [],
    active: false,
    url: routeConfig.Finances.url
  },
  {
    name: routeConfig.Warnings.name,
    icon: WarningsIcon,
    subMenus: [],
    active: false,
    url: routeConfig.Warnings.url,
    urlKey: routeConfig.Warnings.url
  },
  {
    name: routeConfig.BIIReporting.name,
    icon: BIIReportingIcon,
    subMenus: [],
    active: false,
    url: routeConfig.BIIReporting.url
  }
];
